export default __webpack_public_path__ + "static/media/professionalDetailshelpHighlight.73affd14.png";